import React from 'react';
import PropTypes from 'prop-types';
import { CustomAutocomplete, Dropdown, RangeDatePicker, PrimaryButton } from '@myplay/ui';

import { toTitleCase, capitalize } from '../../utils/stringManipulations';
import I18N from '../../I18N';
import { NAME, TITLE } from '../../utils/constants';
import { GREEN_LIGHT, WHITE } from '../../styles/colors';


const SearchPanel = ({ 
  teams, 
  videos, 
  categories, 
  onRangePick, 
  onFilter, 
  onTeamSelect, 
  onCategorySelect, 
  onSearchChange, 
  onClearFilters, 
  selectedTeam, 
  selectedCategory, 
  filteredVideoTitle, 
  selectedRange 
}) => {
  return (
    <div className="videos__search-panel">
      <CustomAutocomplete
        placeholder={toTitleCase(I18N.t("SEARCH_VIDEO"))}
        items={videos}
        propertyToFilterBy={TITLE}
        onSelect={game => onSearchChange(game.title)}
        onChange={onSearchChange}
        initialValue={filteredVideoTitle}
      />
      <Dropdown
        placeholder={toTitleCase(I18N.t("ALL_TEAMS"))}
        items={teams}
        displayedProperty={NAME}
        style={{ flexBasis: "45%" }}
        onSelect={onTeamSelect}
        selectAllText={toTitleCase(I18N.t("ALL_TEAMS"))}
        placeholderColor="#737373"
        selectedItem={selectedTeam}
        hasSelectAllOption
      />
      <Dropdown
        placeholder={toTitleCase(I18N.t("ALL_SPORTS"))}
        items={categories}
        displayedProperty={NAME}
        style={{ flexBasis: "45%" }}
        onSelect={onCategorySelect}
        selectAllText={toTitleCase(I18N.t("ALL_SPORTS"))}
        placeholderColor="#737373"
        selectedItem={selectedCategory}
        hasSelectAllOption
      />
      <RangeDatePicker 
        onRangePick={onRangePick}
        initialRange={selectedRange}
      />
      <PrimaryButton
        color={WHITE}
        background={GREEN_LIGHT}
        onClick={onFilter}
      >
        {toTitleCase(I18N.t("SEARCH"))}
      </PrimaryButton>
      <button onClick={onClearFilters}>
        {capitalize(I18N.t("CLEAR_FILTERS"))}
      </button>
    </div>
  );
};

SearchPanel.propTypes = {
  categories: PropTypes.array, 
  filteredVideoTitle: PropTypes.string, 
  onCategorySelect: PropTypes.func,
  onClearFilters: PropTypes.func,  
  onFilter: PropTypes.func, 
  onRangePick: PropTypes.func, 
  onSearchChange: PropTypes.func, 
  onTeamSelect: PropTypes.func, 
  selectedCategory: PropTypes.string,
  selectedRange: PropTypes.object,   
  selectedTeam: PropTypes.object, 
  teams: PropTypes.array,  
  videos: PropTypes.array 
};

SearchPanel.defaultProps = {
  categories: [],
  filteredVideoTitle: "",  
  onCategorySelect: ()=> {},
  onClearFilters: ()=> {},  
  onFilter: ()=> {}, 
  onRangePick: ()=> {}, 
  onSearchChange: ()=> {}, 
  onTeamSelect: ()=> {},
  selectedCategory: "",
  selectedRange: null, 
  selectedTeam: null ,  
  teams: [], 
  videos: [] 
};

export default SearchPanel;